import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.layoutComponent), {
    content: _ctx.content,
    "is-reversed-layout": _ctx.isReversedLayout,
    class: "o-tile-wrapper"
  }, null, 8, ["content", "is-reversed-layout"]))
}